import { render, staticRenderFns } from "./SubPatient.vue?vue&type=template&id=58d6fcb1&scoped=true&"
import script from "./SubPatient.vue?vue&type=script&lang=ts&"
export * from "./SubPatient.vue?vue&type=script&lang=ts&"
import style0 from "./SubPatient.vue?vue&type=style&index=0&id=58d6fcb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6fcb1",
  null
  
)

export default component.exports